// Created by: Quang Nguyen
import axios from "axios";
import * as key from "./api-keys";
const instance = axios.create({
  baseURL: `https://${key.nDexio.project_id}.firebaseio.com/`,
});

export default instance;
